/**
 * Shows which mock test account is currently "logged in" and lets you
 * log out back to the default. Only meaningful while there's no real
 * auth system — remove once Phase 2 auth lands and this becomes a real
 * account menu.
 */
import { LogOut, UserCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { clearMockSession, useMockSession } from '@/lib/mockSession';

export function TestSessionBadge({ variant = 'bar' }: { variant?: 'bar' | 'compact' }) {
  const session = useMockSession();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearMockSession();
    navigate('/login');
  };

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2 text-xs">
        <UserCircle2 className="h-4 w-4 flex-shrink-0 text-slate-500" />
        <div className="min-w-0 flex-1">
          <p className="truncate font-medium text-slate-900">{session.displayName}</p>
          <p className="truncate text-slate-500">{session.roleLabel}</p>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          aria-label="Log out"
          className="flex-shrink-0 text-slate-400 hover:text-slate-700"
        >
          <LogOut className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-xs text-amber-900 lg:hidden">
      <span className="truncate">
        Testing as <span className="font-semibold">{session.displayName}</span> ·{' '}
        {session.roleLabel}
      </span>
      <button
        type="button"
        onClick={handleLogout}
        className="flex flex-shrink-0 items-center gap-1 font-semibold text-amber-700 hover:text-amber-900"
      >
        <LogOut className="h-3 w-3" />
        Log out
      </button>
    </div>
  );
}
